import { env } from '#src/env.mjs';

export const useAuthenticationRequestsOnEdgeFunctions = () => {
  /**
   * Env variable to easily allow us to go back to the previous way of login in case of issues.
   */
  return env.NEXT_PUBLIC_ENABLE_LEGACY_CANARY_AUTHENTICATION === false;
};
